module.exports = __webpack_public_path__ + "videos/careers_1x1.34b8281.mp4";